// extracted by mini-css-extract-plugin
export default {"tableFooter":"style_tableFooter__fVv8L","pagination":"style_pagination__fYQ5Y","activeButton":"style_activeButton__LbH9p","displayingData":"style_displayingData__Y36Ao"};